/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { useSelector, useDispatch } from 'react-redux';
import { maintainLogCheckListData, setLogCheckTab } from '../../store/Actions';
import * as constantMessageData from '../../../../../SharedModules/Errors/constantMessageData';

export default (props) => {
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
  const dispatch = useDispatch();
  const addNewRowLogCheckList = (data, action) => {
    return dispatch(maintainLogCheckListData(data, action));
  };
  const logCheckRowData = useSelector((state) => {
    return state.sharedState.CheckLogReducer.logCheckList;
  });
  const { commonDropdownList } = props;
  let rowIndex = 0;
  if (logCheckRowData && logCheckRowData.length > 0) {
    rowIndex = logCheckRowData.findIndex((x) => {
      return x.checkLogNum === props.data.checkLogNum;
    });
  }
  const logCheckTabData = useSelector((state) => {
    return state.sharedState.CheckLogReducer.logCheckTabObj;
  });
  // handing Onchange event & check validation on filed level
  const handleChangeSelect = (e) => {
    const errorArray = [];
    const newObj = [...logCheckRowData];
    const { colId } = props.column;
    const { value } = e.target;
    newObj[rowIndex].rowWithNewChange = true;
    if (value === '-1' || value === null) {
      props.node.setDataValue(colId, value);
      newObj[rowIndex][props.column.colId] = value;
      if (props.checkPayeeCd) {
        newObj[rowIndex].checkPayeeCDErr = true;
        errorArray.push(
          `${constantMessageData.CHECK_PAYEE_REQUIRED} [${newObj[rowIndex]?.checkLogNum}].`
        );
      }
      addNewRowLogCheckList(newObj, 'verify');
    } else {
      props.node.setDataValue(colId, value);
      newObj[rowIndex][props.column.colId] = value;
      if (props.checkPayeeCd) {
        newObj[rowIndex].checkPayeeCDErr = false;
        let temp = errorArray?.map((item, key) => {
          if (
            item?.includes(constantMessageData.CHECK_PAYEE_REQUIRED) &&
            item?.includes(newObj[rowIndex]?.checkLogNum)
          ) {
            errorArray.splice(key, 1);
          }
        });
      }
      if (props.paymentMediaTypeCd)
        newObj[rowIndex].paymentMediaTypeCDErr = false;
      if (props.disputeResolutionCd)
        newObj[rowIndex].disputeResolutionCDErr = false;
      addNewRowLogCheckList(newObj, 'verify');
    }
    dispatch(
      setLogCheckTab({
        ...logCheckTabData,
        errorMessages: [...new Set(errorArray)],
      })
    );
  };

  return (
    <div data-testid="check-log-select-box">
      {props?.disputeResolutionCd ? (
        <TextField
          id={`${props.column.colId} ${rowIndex}`}
          className="frr-display-hidden-label"
          label={props.column.colId}
          data-testid="dispute-resolution"
          autoFocus={props.data && props.data.disputeResolutionCDActiveCursor}
          fullWidth
          select
          placeholder=""
          tabIndex={10}
          inputProps={{
            id: `${props.column.colId} ${rowIndex}`,
          }}
          InputLabelProps={{
            shrink: true,
          }}
          value={props.value}
          onChange={(e) => {
            handleChangeSelect(e);
          }}
          onKeyDown={(e) => {
            setIsKeyboardOpen(true);
            if (
              ((e.key === 'Tab' && !e.shiftKey) || e.key === 'ArrowRight') &&
              logCheckRowData.length === props.rowIndex + 1
            ) {
              e.preventDefault();
              props.addNewRow(e);
            }
          }}
          onMouseDown={() => {
            setIsKeyboardOpen(false);
          }}
          onClose={() => {
            setIsKeyboardOpen(false);
          }}
        >
          <MenuItem key="" value="-1" className="frr-dropdown-blank-item" />
          {commonDropdownList?.DISPUTE_RESOLUTION_CD?.map((item) => {
            return (
              <MenuItem
                key={item.codeValueID && item.codeValueID.codeValue}
                value={item.codeValueID && item.codeValueID.codeValue}
                className={isKeyboardOpen ? 'frr-logcheck-dropdown-item' : ''}
                classes={{
                  root: 'frr-menu-item-root',
                  selected: 'frr-menu-item-selected'
                }}
              >
                {`${item.codeValueID && item.codeValueID?.codeValue} | ${
                  item.shortDescription
                }`}
              </MenuItem>
            );
          })}
        </TextField>
      ) : props.checkPayeeCd ? (
        <TextField
          id={`${props.column.colId} ${rowIndex}`}
          label={props.column.colId}
          data-testid="check-payee"
          autoFocus={props.data && props.data.checkPayeeCDActiveCursor}
          className={
            logCheckRowData &&
            logCheckRowData[rowIndex] &&
            logCheckRowData[rowIndex].checkPayeeCDErr !== undefined &&
            logCheckRowData[rowIndex].checkPayeeCDErr
              ? 'frr-display-hidden-label td-active-cell tBill-validate'
              : 'frr-display-hidden-label'
          }
          inputProps={{
            id: `${props.column.colId} ${rowIndex}`,
          }}
          fullWidth
          select
          placeholder=""
          InputLabelProps={{
            shrink: true,
          }}
          value={props.value}
          onChange={(e) => {
            handleChangeSelect(e);
          }}
          onKeyDown={(e) => {
            setIsKeyboardOpen(true);
            if (e.keyCode == 9) {
              const tempObj = [...logCheckRowData];
              if (e.shiftKey) {
                tempObj[rowIndex].checkPayeeCDActiveCursor = false;
                tempObj[rowIndex].paymentMediaTypeCDActiveCursor = false;
                tempObj[rowIndex].disputeResolutionCDActiveCursor = false;
              } else {
                tempObj[rowIndex].checkPayeeCDActiveCursor = false;
                tempObj[rowIndex].paymentMediaTypeCDActiveCursor = true;
                tempObj[rowIndex].disputeResolutionCDActiveCursor = false;
              }
              addNewRowLogCheckList(tempObj, 'verify');
            }
          }}
          onMouseDown={() => {
            setIsKeyboardOpen(false);
          }}
          onClose={() => {
            setIsKeyboardOpen(false);
          }}
        >
          <MenuItem key="" value="-1" className="frr-dropdown-blank-item" />
          {commonDropdownList?.CHECK_PAYEE_CD?.map((item) => {
            return (
              <MenuItem
                key={item.codeValueID && item.codeValueID.codeValue}
                value={item.codeValueID && item.codeValueID.codeValue}
                className={isKeyboardOpen ? 'frr-logcheck-dropdown-item' : ''}
                classes={{
                  root: 'frr-menu-item-root',
                  selected: 'frr-menu-item-selected'
                }}
              >
                {`${item.codeValueID && item.codeValueID.codeValue} | ${
                  item.shortDescription
                }`}
              </MenuItem>
            );
          })}
        </TextField>
      ) : (
        <TextField
          id={`${props.column.colId} ${rowIndex}`}
          label={props.column.colId}
          className="frr-set-Ellipsis frr-display-hidden-label"
          data-testid="payment-media_type"
          autoFocus={props.data && props.data.paymentMediaTypeCDActiveCursor}
          fullWidth
          select
          placeholder=""
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            id: `${props.column.colId} ${rowIndex}`,
          }}
          value={props.value}
          onChange={(e) => {
            handleChangeSelect(e);
          }}
          onKeyDown={(e) => {
            setIsKeyboardOpen(true);
            if (e.keyCode == 9) {
              const tempObj = [...logCheckRowData];
              if (e.shiftKey) {
                tempObj[rowIndex].checkPayeeCDActiveCursor = true;
                tempObj[rowIndex].paymentMediaTypeCDActiveCursor = false;
                tempObj[rowIndex].disputeResolutionCDActiveCursor = false;
              } else {
                tempObj[rowIndex].checkPayeeCDActiveCursor = false;
                tempObj[rowIndex].paymentMediaTypeCDActiveCursor = false;
                tempObj[rowIndex].disputeResolutionCDActiveCursor = true;
              }
              addNewRowLogCheckList(tempObj, 'verify');
            }
          }}
          onMouseDown={() => {
            setIsKeyboardOpen(false);
          }}
          onClose={() => {
            setIsKeyboardOpen(false);
          }}
        >
          <MenuItem key="" value="-1" className="frr-dropdown-blank-item" />
          {commonDropdownList?.PAYMENT_MEDIA_TYPE_CD?.map((item) => {
            return (
              <MenuItem
                key={item.codeValueID && item.codeValueID.codeValue}
                value={item.codeValueID && item.codeValueID.codeValue}
                className={isKeyboardOpen ? 'frr-logcheck-dropdown-item' : ''}
                classes={{
                  root: 'frr-menu-item-root',
                  selected: 'frr-menu-item-selected'
                }}
              >
                {`${item.codeValueID && item.codeValueID.codeValue} | ${
                  item.shortDescription
                }`}
              </MenuItem>
            );
          })}
        </TextField>
      )}
    </div>
  );
};
